import React, { useEffect } from 'react';
import styles from './styles.module.less';
// import {
//   UserOutlined,
//   TeamOutlined,
//   SolutionOutlined
// } from '@ant-design/icons';
import { Row, Col, Image } from 'antd';

const Aboutme = ({ profiles }) => {
  console.log('user_data', profiles);
  // const profileNames = profiles?.map((profile) => profile.profile_name);

  useEffect(() => {
    profiles?.forEach((profile) => {
      console.log('Profile Name:', profile.profile_name);
    });
  }, [profiles]);

  // const profile = response[0];
  const hobbies =
    profiles?.[0]?.ProfileInterests.filter(
      (item) => item?.HobbySport?.type === 'hobby'
    )
      .map((item) => item?.HobbySport?.activity)
      .join(', ') || 'Not provided';

  const sports =
    profiles?.[0]?.ProfileInterests.filter(
      (item) => item?.HobbySport?.type === 'sport'
    )
      .map((item) => item?.HobbySport?.activity)
      .join(', ') || 'Not provided';

  const currency = profiles?.[0]?.Currency?.currency_code || 'Not provided';
  console.log('currency', currency);
  const aboutMe = {
    profileManagedBy:
      profiles?.[0]?.ProfileForType?.profile_for_type || 'Not provided',
    // === 'MySelf'
    //   ? 'MySelf'
    //   : 'Parents',
    maritalStatus:
      profiles?.[0]?.MaritalStatus?.marital_status || 'Not provided',
    age: profiles?.[0]?.calculated_age,
    residingLocation: profiles?.[0]?.City?.city || 'Not provided',
    // height: `${profiles?.[0]?.height_ft} ft ${profiles?.[0]?.height_in} in`,
    // height:
    //   profiles?.[0]?.height_ft && profiles?.[0]?.height_in
    //     ? `${profiles?.[0]?.height_ft} ft ${profiles?.[0]?.height_in} in`
    //     : 'N/A',
    height: profiles?.[0]?.height_cms
      ? `${profiles?.[0]?.height_cms} cm`
      : 'Not provided',

    weight: profiles?.[0]?.weight
      ? `${profiles?.[0]?.weight} kg`
      : 'Not provided',
    // annualIncome: formatAnnualIncome(profiles?.[0]?.annual_income),
    // annualIncome: profiles?.[0]?.annual_income || 'N/A',
    // annualIncome: profiles?.[0]?.annual_income
    //   ? Number(profiles?.[0]?.annual_income).toLocaleString()
    //   : 'N/A',
    // currency: profiles?.[0]?.currency_code || 'N/A',
    // annualIncome: profiles?.[0]?.annual_income
    //   ? new Intl.NumberFormat('en-US', {
    //       style: 'currency',
    //       currency: currency
    //     }).format(Number(profiles?.[0]?.annual_income))
    //   : 'N/A',
    annualIncome: profiles?.[0]?.annual_income
      ? new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency:
            profiles?.[0]?.currency_code &&
            profiles?.[0]?.currency_code !== 'N/A'
              ? profiles?.[0]?.currency_code
              : 'INR' // Default to USD if currency is 'N/A' or missing
        }).format(Number(profiles?.[0]?.annual_income))
      : 'Not provided',

    self_description: profiles?.[0]?.self_description || 'Not provided',

    hobbies: hobbies,
    sports: sports,
    otherInterest: profiles?.[0]?.other_interests || 'Not provided',
    disability_text: profiles?.[0]?.is_disabled === true ? 'Yes' : 'None',
    diabled_description: profiles?.[0]?.diabled_description || 'Not provided'
  };

  // function formatAnnualIncome(income) {
  //   const amount = parseInt(income, 10);
  //   if (amount >= 700000 && amount <= 800000) return '7 - 8L';
  //   return `${(amount / 100000).toFixed(0)}L`;
  // }

  const profileImages = profiles?.[0]?.ProfileImages || [];
  console.log('profileImages', profileImages);

  const handleImageError = (e) => {
    e.target.src = '/images/placeholder.png'; // Provide a fallback image
  };

  const placeholders = [
    { label: 'Profile Photo', icon: '/icons/profile-icon.png' },
    { label: 'Family Photo', icon: '/icons/family-icon.png' },
    { label: 'Self/Family Photo', icon: '/icons/self-family-icon.png' }
  ];

  return (
    <>
      <Row className={styles.profileImagesRow} gutter={16}>
        {placeholders.map((placeholder, index) => (
          <Col key={index} span={8}>
            {profileImages?.[index]?.objectKey ? (
              <Image
                src={profileImages[index].objectKey}
                alt={profileImages[index].originalName || placeholder.label}
                className={styles.profileImage}
                width={220}
                height={150}
                onError={handleImageError}
                // preview={{
                //   visible: false
                // }}
                // preview={false}
                onClick={() =>
                  Image.PreviewGroup.open({
                    src: profileImages[index].objectKey
                  })
                }
              />
            ) : (
              <div className={styles.placeholderBox}>
                <img
                  src={placeholder.icon}
                  alt={placeholder.label}
                  className={styles.placeholderIcon}
                />
              </div>
            )}
            <p className={styles.imageLabel}>{placeholder.label}</p>
          </Col>
        ))}
      </Row>

      <Row
        className={styles.Aboutme}
        // style={{    marginLeft: "-35px",borderBottom:"1px solid #d20b0b",color:"#d20b0b",width:"15%"}}
      >
        About Me
      </Row>
      <Row style={{ color: '#d20b0b' }}>
        <span className={styles.sport}>{aboutMe?.self_description}</span>
      </Row>

      <Row
        gutter={24}
        className={styles.profileRow}
        // style={{ gap: ' 50px' }}
        // justify="space-between"
      >
        {/* Profile Managed By */}
        {/* <Col span={6} className={styles.profileCol}>
          <span className={styles.label}>Profile managed for</span>
          <div className={styles.value}> {aboutMe?.profileManagedBy} </div>
        </Col> */}

        {/* Age */}
        <Col span={8} className={styles.profileCol}>
          <span className={styles.label}>Age</span>
          <div className={styles.value}>
            {/* {aboutMe?.age}  */}
            {aboutMe?.age ? `${aboutMe.age} Years` : 'Not provided'}
          </div>
        </Col>

        {/* Height */}
        <Col span={8} className={styles.profileCol}>
          <span className={styles.label}>Height</span>
          <div className={styles.value}> {aboutMe?.height} </div>
        </Col>

        {/* Weight */}
        <Col span={8} className={styles.profileCol}>
          <span className={styles.label}>Weight</span>
          <div className={styles.value}> {aboutMe?.weight} </div>
        </Col>
      </Row>
      <Row
        gutter={24}
        className={styles.profileRow}
        style={{ paddingTop: '20px' }}
        // justify="space-between"
      >
        {/* Marital Status */}
        <Col span={8} className={styles.profileCol}>
          <span className={styles.label}>Marital Status</span>
          <div className={styles.value}> {aboutMe?.maritalStatus} </div>
        </Col>

        {/* Annual Income */}
        <Col span={8} className={styles.profileCol}>
          <span className={styles.label}>Annual Income</span>
          <div className={styles.value}> {aboutMe?.annualIncome} </div>
        </Col>

        {/* Residing Location */}
        <Col span={8} className={styles.profileCol}>
          <span className={styles.label}>Residing Location</span>
          <div className={styles.value}> {aboutMe?.residingLocation} </div>
        </Col>
      </Row>

      {/* <Row gutter={24} className={styles.photoRow} style={{ gap: ' 50px' }}>
        Profile Photo
        <Col span={6}>
          <Card className={styles.photoCard} bordered={true}>
            <UserOutlined className={styles.icon} />
          </Card>
          <div className={styles.labels}>*Profile Photo</div>
        </Col>

        Family Photo
        <Col span={6}>
          <Card className={styles.photoCard} bordered={true}>
            <TeamOutlined className={styles.icon} />
          </Card>
          <div className={styles.labels}>*Family Photo</div>
        </Col>

        Self/Family Photo
        <Col span={6}>
          <Card className={styles.photoCard} bordered={true}>
            <SolutionOutlined className={styles.icon} />
          </Card>
          <div className={styles.labels}>Self/Family Photo</div>
        </Col>
      </Row> */}

      {/* Profile Images Section */}
      {/* <Row className={styles.profileImagesRow} gutter={16}>
        {profileImages?.length > 0 ? (
          <Image.PreviewGroup>
            {profileImages.map((image, index) => (
              <Col key={image.id || index} span={8}>
                <Image
                  src={image.objectKey}
                  alt={image.originalName || `Profile Image ${index + 1}`}
                  className={styles.profileImage}
                  width={150}
                  height={150}
                  onError={handleImageError}
                  preview={{
                    visible: false // Hide inline preview
                  }}
                  onClick={() =>
                    Image.PreviewGroup.open({
                      src: image.objectKey
                    })
                  }
                />
                <p>{image.image_type}</p>
              </Col>
            ))}
          </Image.PreviewGroup>
        ) : (
          <Col span={24} style={{ textAlign: 'center' }}>
            <p>No Profile Images Available</p>
          </Col>
        )}
      </Row> */}
      {/* Above working code */}

      {/*  */}

      {/* <Row
        className={styles.Aboutme}
        // style={{    marginLeft: "-35px",borderBottom:"1px solid #d20b0b",color:"#d20b0b",width:"15%"}}
      >
        Disabilities
      </Row>
      <Row style={{ color: '#d20b0b' }}>
        <span className={styles.sport}>{aboutMe?.disability_text}</span>
      </Row> */}

      <Row className={styles.hobbies}>
        <Col className={styles.colStyle}>
          <span className={styles.hob}>Hobbies</span>
          <span className={styles.sport}> {aboutMe?.hobbies} </span>
        </Col>
        <Col className={styles.colStyle}>
          <span className={styles.hob}>Sports</span>
          <span className={styles.sport}> {aboutMe?.sports} </span>
        </Col>
      </Row>
      <Row className={styles.hobbies}>
        <Col className={styles.colStyle}>
          <span className={styles.other}>Disabilities</span>
          {/* <span className={styles.sport}> {aboutMe?.disability_text} </span> */}
          <span className={styles.sport}>
            {aboutMe?.disability_text === 'Yes' && aboutMe?.diabled_description
              ? aboutMe.diabled_description
              : 'None'}
          </span>
        </Col>

        {/* {aboutMe?.disability_text === 'Yes' && (
          <Col className={styles.colStyle}>
            <span className={styles.disability}>Disabilities Description</span>
            <span className={styles.sport}>
              {aboutMe?.diabled_description || 'N/A'}
            </span>
          </Col>
        )} */}

        <Col className={styles.colStyle}>
          <span className={styles.other}>Other Interest</span>
          <span className={styles.sport}> {aboutMe?.otherInterest} </span>
        </Col>
      </Row>
    </>
  );
};

export default Aboutme;
